import { TypeOf, yup } from '@guiker/yup-util'

export const searchByIds = yup.object({
  ids: yup.array().of(yup.string()),
  attributes: yup.array().of(yup.string()).nullable(),
})

export type SearchByIds = TypeOf<typeof searchByIds>
